import React from 'react';
import type { ImageBlock } from '@/types/contentBlocks';

interface ImageBlockProps {
  block: ImageBlock;
  isDarkMode: boolean;
}

export const ImageBlockRenderer: React.FC<ImageBlockProps> = ({ block, isDarkMode }) => {
  return (
    <div className="my-4">
      <img
        src={block.url}
        alt={block.alt}
        title={block.title}
        className="max-w-full h-auto rounded-lg shadow-md"
      />
      {block.alt && (
        <p className={`text-sm text-center mt-2 ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>
          {block.alt}
        </p>
      )}
    </div>
  );
};
